<template>
  <div class="service-area pt--70 pb--50 bg_color--1">
    <v-container>
      <v-row>
        <v-col cols="12">
          <div class="text-center section-title mb--30">
            <h2 class="heading-title">Corporate Housing</h2>
            <p class="description">
              Quality affordable accommodation for your team
            </p>
          </div>
        </v-col>
      </v-row>
      <v-row class="service-main-wrapper bg-white--service">
        <v-col
          offset-sm="3"
          sm="6"
          cols="12"
          v-for="(listGroup, i) in listInfo"
          :key="i"
        >
          <div class="service service__style--2 text-left bg-gray">
            <div class="service">
              <div class="icon">
                <div v-html="iconSvg(listGroup.icon)"></div>
              </div>
              <div class="content">
                <h3 class="heading-title">{{ listGroup.title }}</h3>
                <ul class="list-style--1">
                  <li
                    class="d-flex"
                    v-for="(item, j) in listGroup.list"
                    :key="j"
                  >
                    <i v-html="iconSvg(item.icon)"></i>
                    {{ item.desc }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import feather from "feather-icons";
export default {
  data() {
    return {
      listInfo: [
        {
          icon: "users",
          title: "Corporate Housing",
          list: [
            {
              icon: "check",
              desc: `Are you a recruitment company sending contractors to Birmingham and need quality accommodation?`,
            },
            {
              icon: "check",
              desc: `Are you fed up of high hotel bills and expenses for your team based in Birmingham & the Black Country?`,
            },
            {
              icon: "check",
              desc: `We offer a homely experience away from home for your staff.`,
            }
          ],
        },
      ],
    };
  },
  methods: {
    iconSvg(icon) {
      return feather.icons[icon].toSvg();
    },
  },
};
</script>
